import { Component, ViewEncapsulation, Input } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { MenuService } from '@core/bootstrap/menu.service';
import { filter } from 'rxjs';

@Component({
  selector: 'breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BreadcrumbComponent {
  @Input() nav: string[] = [];

  constructor(private router: Router, private menu: MenuService) {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      this.genBreadcrumb();
    });
  }

  genBreadcrumb() {
    const states = this.router.url.slice(1).split('/');
    this.nav = this.menu.getMenuLevel(states);
    this.nav.unshift('home');

    if (states[1] === 'profile') {
      this.nav.push('menu.profile');
    }
  }

  trackByNavlink(_index: number, navlink: string): string {
    return navlink;
  }
}
